import Router from "vue-router";
import Vue from "vue";
import store from "@/store";
Vue.use(Router);
const vueRouter = new Router({
  base: process.env.VUE_APP_PATH,
  mode: process.env.VUE_APP_MODE,
  routes: [
    {
      path: "/welcome",
      component: () =>
        import(/* webpackChunkName: "page" */ "@/page/login/welcome"),
    },
    {
      path: "/login",
      component: () =>
        import(/* webpackChunkName: "page" */ "@/page/login/login"),
    },
    {
      path: "/register",
      component: () =>
        import(/* webpackChunkName: "page" */ "@/page/login/register"),
    },
    {
      path: "/forgetPassword",
      component: () =>
        import(/* webpackChunkName: "page" */ "@/page/login/forgetPassword"),
    },
    {
      path: "/",
      component: () => import(/* webpackChunkName: "page" */ "@/page/index"),
      children: [
        {
          path: "",
          component: () => import(/* webpackChunkName: "page" */ "@/page/list"),
        },
        {
          path: "category",
          component: () =>
            import(/* webpackChunkName: "page" */ "@/page/list/category"),
            // import(/* webpackChunkName: "page" */ "@/page/list/categoryNew"),
        },
        {
          path: "db",
          component: () =>
            import(/* webpackChunkName: "page" */ "@/page/list/db"),
        },
        {
          path: "map",
          component: () =>
            import(/* webpackChunkName: "page" */ "@/page/list/map"),
        },
        {
          path: "components",
          component: () =>
            import(/* webpackChunkName: "page" */ "@/page/list/components"),
        },
        {
          path: "record",
          component: () =>
            import(/* webpackChunkName: "page" */ "@/page/list/record"),
        },
      ],
    },
    {
      path: "/create",
      name: "create",
      component: () => import(/* webpackChunkName: "page" */ "@/page/create"),
    },
    {
      path: "/build/:id",
      name: "build",
      component: () => import(/* webpackChunkName: "page" */ "@/page/build"),
    },
    {
      path: "/view/:id",
      name: "view",
      component: () => import(/* webpackChunkName: "page" */ "@/page/view"),
    },
  ],
});
vueRouter.beforeEach((to, from, next) => {
  let isLogin = store.state.user.token || null
  let noTokenPage = ["/welcome", "/login", "/register", "/forgetPassword"];
  if (isLogin) {
    //如果用户信息存在则往下执行。
    next();
  } else {
    //如果用户token不存在则跳转到login页面
    if (noTokenPage.indexOf(to.path) !== -1) {
      next();
    } else {
      next("/welcome");
    }
  }
});
export default vueRouter;
